import { useQuery, useMutation } from '@tanstack/react-query';
import { getOnboardingMessages, getRevisitOnboardingMessages, updateOnboardingMessage } from '../services';
import { useUserInfo } from 'app/hooks/useUserInfo';
import type { UpdateOnboardingMessageRequest } from '../types';
import { useLocation } from 'react-router-dom';
import { ROOT } from 'configs/routeNames';

export const ONBOARDING_MESSAGES_QUERY_KEY = ['onboarding-messages'] as const;
export const REVISIT_ONBOARDING_MESSAGES_QUERY_KEY = ['revisit-onboarding-messages'] as const;

export const useOnboardingMessages = () => {
  const { data: userInfo } = useUserInfo();
  const userId = userInfo?.userId;
  const location = useLocation();

  return useQuery({
    queryKey: [...ONBOARDING_MESSAGES_QUERY_KEY, userId],
    queryFn: () => getOnboardingMessages(userId?.toString() || ''),
    enabled: !!userId && location.pathname === ROOT,
  });
};

export const useUpdateOnboardingMessage = () => {
  const { data: userInfo } = useUserInfo();
  const userId = userInfo?.userId;

  return useMutation({
    mutationFn: (payload: Omit<UpdateOnboardingMessageRequest, 'userId'>) => {
      if (!userId) throw new Error('User ID is required');
      return updateOnboardingMessage({ ...payload, userId });
    },
  });
};

export const useRevisitOnboardingMessages = (enabled: boolean = false) => {
  const { data: userInfo } = useUserInfo();
  const userId = userInfo?.userId;

  return useQuery({
    queryKey: [...REVISIT_ONBOARDING_MESSAGES_QUERY_KEY, userId],
    queryFn: () => getRevisitOnboardingMessages(userId?.toString() || ''),
    enabled: enabled && !!userId,
  });
};
